/** @format */

const template = `
<ng-form name="{{::ctrl.name}}">
  <div class="row">
    <div class="col-md-12 col-12">
      <div class="localized-string-label">
        <ng-transclude></ng-transclude>
        <sis-language-pills
          data-cy="localized-string-editor-lang"
          [invalid-locales]="ctrl.invalidLangFields"
          [scope]="ctrl.scope"
          [(selected-language)]="ctrl.selectedLocale"
          (selected-language-change)="ctrl.focusLocaleInput($event)"></sis-language-pills>
      </div>
      <p ng-if="ctrl.guidanceText" class="guidance">{{::ctrl.guidanceText}}</p>
      <div class="tab-content">
        <div ng-repeat="locale in ctrl.supportedLocales track by $index">
          <input
            name="{{::locale}}"
            ng-if="!ctrl.useTextArea"
            id="{{::ctrl.getInputFieldId(locale)}}"
            class="form-control string-input"
            ng-class="{ active: ctrl.isSelectedLocale(locale), 'has-error': ctrl.form[ctrl.name][locale].$invalid }"
            type="text"
            ng-model="ctrl.ngModel.$viewValue[locale]"
            ng-model-options="{ allowInvalid: true, debounce: ctrl.modelDebounce ? ctrl.modelDebounce : 0 }"
            ng-change="ctrl.onChange()"
            ng-minlength="ctrl.realMinLength"
            ng-maxlength="ctrl.maxLength"
            ng-focus="ctrl.selectLocale(locale)"
            ng-required="!ctrl.form[ctrl.name].$pristine
                           && (ctrl.ngModel.$error.requireTranslations||ctrl.ngModel.$error.requireAllTranslations)"
            ng-readonly="ctrl.readonly ? ctrl.readonly : false"
            placeholder="{{ ctrl.placeholder | translate }}"
            tabindex="0"
            autocomplete="off" />
          <textarea
            name="{{::locale}}"
            ng-if="ctrl.useTextArea"
            id="{{::ctrl.getTextareaFieldId(locale)}}"
            class="form-control string-input"
            ng-class="{ active: ctrl.isSelectedLocale(locale), 'has-error': ctrl.form[ctrl.name][locale].$invalid }"
            type="text"
            ng-model="ctrl.ngModel.$viewValue[locale]"
            ng-model-options="{ allowInvalid: true, debounce: ctrl.modelDebounce ? ctrl.modelDebounce : 0 }"
            ng-change="ctrl.onChange()"
            ng-minlength="ctrl.realMinLength"
            ng-maxlength="ctrl.maxLength"
            ng-focus="ctrl.selectLocale(locale)"
            ng-required="!ctrl.form[ctrl.name].$pristine
                           && (ctrl.ngModel.$error.requireTranslations||ctrl.ngModel.$error.requireAllTranslations)"
            ng-readonly="ctrl.readonly ? ctrl.readonly : false"
            placeholder="{{ ctrl.placeholder | translate }}"
            tabindex="0"
            autocomplete="off"></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-12">
      <ul
        ng-if="!ctrl.hideErrors && ctrl.form[ctrl.name].$invalid"
        class="error-list"
        ng-messages="ctrl.form[ctrl.name].$error"
        ng-messages-multiple="true"
        role="alert">
        <li ng-message="minlength" translate translate-value-langnames="{{ ctrl.errors('minlength') | localeNames | localizedStringArray }}"
          >SIS_COMPONENTS.STRING.LOCALIZED_STRING_EDITOR.TOO_SHORT</li
        >
        <li ng-message="maxlength" translate translate-value-langnames="{{ ctrl.errors('maxlength') | localeNames | localizedStringArray }}"
          >SIS_COMPONENTS.STRING.LOCALIZED_STRING_EDITOR.TOO_LONG</li
        >
        <li ng-message="required" ng-if="!ctrl.ngModel.$error.requireAllTranslations" translate
          >SIS_COMPONENTS.STRING.LOCALIZED_STRING_EDITOR.REQUIRED</li
        >
        <li ng-message="required" ng-if="ctrl.ngModel.$error.requireAllTranslations" translate
          >SIS_COMPONENTS.STRING.LOCALIZED_STRING_EDITOR.ALL_REQUIRED</li
        >
      </ul>
    </div>
  </div>
</ng-form>
`;
export default template;
